import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Col, ListGroup } from 'react-bootstrap';

import PerfectScrollBar from 'react-perfect-scrollbar';

import { MdVerifiedUser, MdPhone } from 'react-icons/md';
import { GoUnverified } from 'react-icons/go';
import {
  makeGetToken,
  makeGetDefaultAccount,
  makeGetAuth,
  makeGetCustomerBankAccount,
} from '../../lib/selector';
import { setAuth, setChangeBank } from '../../containers/client/actions';
import { translate } from 'react-i18next';
class Bank extends React.Component {
  _handleAuthen = () => {
    this.props.dispatch(setAuth());
  };

  render() {
    const { auth, token, bankAcc, t } = this.props;
    console.log('bankAcc', bankAcc);
    return (
      <PerfectScrollBar>
        <div className="d-flex justify-content-md-center">
          <Col md="6" className="d-flex flex-column">
            <div className="d-flex justify-content-between align-items-center mt-3">
              <label className="text-white fz-18">
                {t('txt-label-bank-account')}
              </label>
              <span className={'fz-14 ' + (auth.isVerified ? 'i' : 'd')}>
                {auth && auth.isVerified ? (
                  <Fragment>
                    <MdVerifiedUser className="mr-2" />
                    {t('txt-da-xacthuc')}
                  </Fragment>
                ) : (
                  <Fragment>
                    <GoUnverified className="mr-2" />
                    {t('txt-chua-xacthuc')}
                  </Fragment>
                )}
              </span>
            </div>
            <ListGroup className="mt-2">
              {bankAcc && bankAcc.bankAccount && !!bankAcc.bankAccount.length && (
                <Fragment>
                  <ListGroup.Item className="d-flex p-2">
                    <span className="fz-14 txt-content w-195">
                      {t('txt-label-account-num')}
                    </span>
                    <span className="fz-14 text-white font-weight-bold">
                      {bankAcc.bankAccount[0].bankAcntNo}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex p-2">
                    <span className="fz-14 txt-content w-195">
                      {t('txt-label-account-holder')}
                    </span>
                    <span className="fz-14 text-white font-weight-bold">
                      {bankAcc.bankAccount[0].bankAcntNm}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex p-2">
                    <span className="fz-14 txt-content w-195">
                      {t('txt-label-beneficiary-bank')}
                    </span>
                    <span className="fz-14 text-white font-weight-bold">
                      {bankAcc.bankAccount[0].bankName}
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex p-2">
                    <span className="fz-14 txt-content w-195">
                      {t('txt-label-branch')}
                    </span>
                    <span className="fz-14 text-white font-weight-bold">
                      {bankAcc.bankAccount[0].branchName}
                    </span>
                  </ListGroup.Item>
                </Fragment>
              )}
            </ListGroup>
            <label className="text-white fz-18 mt-3">
              {t('txt-label-account-second')}
            </label>
            {bankAcc &&
              bankAcc.bankAccount &&
              !!bankAcc.bankAccount.length &&
              bankAcc.bankAccount.map((item, index) => {
                if (index === 0) return null;
                return (
                  <ListGroup className="mt-2" key={'tkphu_' + index}>
                    <ListGroup.Item className="d-flex p-2">
                      <span className="fz-14 txt-content w-195">
                        {t('txt-label-account-num')}
                      </span>
                      <span className="fz-14 text-white font-weight-bold">
                        {item.bankAcntNo}
                      </span>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex p-2">
                      <span className="fz-14 txt-content w-195">
                        {t('txt-label-account-holder')}
                      </span>
                      <span className="fz-14 text-white font-weight-bold">
                        {item.bankAcntNm}
                      </span>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex p-2">
                      <span className="fz-14 txt-content w-195">
                        {t('txt-label-beneficiary-bank')}
                      </span>
                      <span className="fz-14 text-white font-weight-bold">
                        {item.bankName}
                      </span>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex p-2">
                      <span className="fz-14 txt-content w-195">
                        {t('txt-label-branch')}
                      </span>
                      <span className="fz-14 text-white font-weight-bold">
                        {item.branchName}
                      </span>
                    </ListGroup.Item>
                  </ListGroup>
                );
              })}
            {bankAcc &&
              bankAcc.bankAccount &&
              bankAcc.bankAccount.length < 2 && (
                <p className="txt-content fz-14 mt-3 mb-3 text-center">
                  {t('txt-no-data-found')}
                </p>
              )}
            {bankAcc &&
              bankAcc.bankAccount &&
              bankAcc.bankAccount.length < 2 &&
              (auth && auth.isVerified ? (
                <Button
                  variant="info"
                  className="fz-14 font-weight-bold text-white mx-auto"
                  onClick={() => this.props.dispatch(setChangeBank())}
                >
                  {t('txt-regis-bank-account')}
                </Button>
              ) : (
                <Button
                  variant="warning"
                  className="fz-14 font-weight-bold text-white w-140 mx-auto"
                  onClick={() => this._handleAuthen()}
                >
                  {t('txt-xacthuc')}
                </Button>
              ))}
            <p className="txt-content fz-14 mt-3 mb-3 text-center">
              {t('txt-hotline-support')}
            </p>
            <a
              href={`tel:02462823535`}
              className="text-center text-white fz-12 mb-3 mx-auto"
              style={{
                width: '120px',
                backgroundColor: '#1BA0E1',
                borderRadius: '18px',
                padding: '5px',
              }}
            >
              <MdPhone className="mr-2" />
              {'0246.282.3535'}
            </a>
          </Col>
        </div>
      </PerfectScrollBar>
    );
  }
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getAuth = makeGetAuth();
  const getCustomerBankAccount = makeGetCustomerBankAccount();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      auth: getAuth(state),
      bankAcc: getCustomerBankAccount(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(translate('translations')(Bank));
